import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import './LabelCreate.css';

const LabelCreate = () => {
  const location = useLocation();
  const [foreignPrefilled, setForeignPrefilled] = useState(false);
  const [formData, setFormData] = useState({
    foreign_key_model: '',
    foreign_key_id: '',
    file_path: '',
    datasets: '',
    annotator: '',
    frame_end_systole: '',
    frame_end_diastole: '',
    frame_random: '',
    side: 'Unknown',
    frame_initial_contrast_appearance: '',
    frame_start_washout: '',
    frame_end_washout: '',
    comments: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
      const searchParams = new URLSearchParams(location.search);
      const dicomId = searchParams.get('dicom_id');
      if (dicomId) {
        setFormData((prev) => ({ ...prev, foreign_key_model: "dicom", foreign_key_id: dicomId }));
        setForeignPrefilled(true);
      }
    }, [location.search]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const payload = {
      foreign_key: {
        modality: formData.foreign_key_model,
        id: parseInt(formData.foreign_key_id, 10),
      },
      file_path: formData.file_path,
      datasets: formData.datasets
        ? formData.datasets.split(",").map((dataset) => dataset.trim())
        : [],
      annotator: formData.annotator,
      frame_end_systole: formData.frame_end_systole ? parseInt(formData.frame_end_systole, 10) : null,
      frame_end_diastole: formData.frame_end_diastole ? parseInt(formData.frame_end_diastole, 10) : null,
      frame_random: formData.frame_random ? parseInt(formData.frame_random, 10) : null,
      side: formData.side,
      frame_initial_contrast_appearance: formData.frame_initial_contrast_appearance ? parseInt(formData.frame_initial_contrast_appearance, 10) : null,
      frame_start_washout: formData.frame_start_washout ? parseInt(formData.frame_start_washout, 10) : null,
      frame_end_washout: formData.frame_end_washout ? parseInt(formData.frame_end_washout, 10) : null,
      comments: formData.comments || null,
    };
  
  
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/patients/fsa_labels/create/`,
        payload,
        { headers: { Authorization: `Token ${token}` } }
      );
      setSuccess(true);
      setError('');
      setFormData({
        foreign_key_model: '',
        foreign_key_id: '',
        file_path: '',
        datasets: '',
        annotator: '',
        frame_end_systole: '',
        frame_end_diastole: '',
        frame_random: '',
        side: 'Unknown',
        frame_initial_contrast_appearance: '',
        frame_start_washout: '',
        frame_end_washout: '',
        comments: '',
      });
    } catch (err) {
      console.error(err);
      setError('Error creating Label. Check fields or try again.');
      setSuccess(false);
    }
  };
  

  return (
    <div className="label-create-container">
      <h3>Create New FSA Label</h3>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">Label created successfully!</p>}

      <form onSubmit={handleSubmit} className="label-create-form">
        <div className="form-group">
          <label>Modality  <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="foreign_key_model"
            value={formData.foreign_key_model}
            onChange={handleChange}
            placeholder='Foreign Key Model. e.g. "dicom"'
            required
            disabled={foreignPrefilled}
          />
        </div>
        <div className="form-group">
          <label>Foregin Key Id  <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="foreign_key_id"
            value={formData.foreign_key_id}
            onChange={handleChange}
            placeholder='Foreign Key ID. e.g. "1"'
            required
            disabled={foreignPrefilled}
          />
        </div>
        <div className="form-group">
          <label>File Path  <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="file_path"
            value={formData.file_path}
            onChange={handleChange}
            placeholder="File Path"
            required
          />
        </div>
        <div className="form-group">
          <label>Datasets</label>
          <input
            type="text"
            name="datasets"
            value={formData.datasets}
            onChange={handleChange}
            placeholder="Comma seperated. e.g. 'dataset1, dataset2'"
          />
        </div>
        <div className="form-group">
          <label>Annotator <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="annotator"
            value={formData.annotator}
            onChange={handleChange}
            placeholder="Annotator name"
            required
          />
        </div>
        
        <h4>Frame Information</h4>
        <div className="form-group">
          <label>Frame End Systole</label>
          <input
            type="number"
            name="frame_end_systole"
            value={formData.frame_end_systole}
            onChange={handleChange}
            placeholder="Frame number for end of systole"
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Frame End Diastole</label>
          <input
            type="number"
            name="frame_end_diastole"
            value={formData.frame_end_diastole}
            onChange={handleChange}
            placeholder="Frame number for end of diastole"
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Frame Random</label>
          <input
            type="number"
            name="frame_random"
            value={formData.frame_random}
            onChange={handleChange}
            placeholder="Random frame number"
            min="0"
          />
        </div>
        
        <div className="form-group">
          <label>Side</label>
          <select
            name="side"
            value={formData.side}
            onChange={handleChange}
          >
            <option value="Unknown">Unknown</option>
            <option value="LCA">LCA</option>
            <option value="RCA">RCA</option>
          </select>
        </div>
        
        <h4>Contrast Information</h4>
        <div className="form-group">
          <label>Frame Initial Contrast Appearance</label>
          <input
            type="number"
            name="frame_initial_contrast_appearance"
            value={formData.frame_initial_contrast_appearance}
            onChange={handleChange}
            placeholder="Frame number for initial contrast appearance"
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Frame Start Washout</label>
          <input
            type="number"
            name="frame_start_washout"
            value={formData.frame_start_washout}
            onChange={handleChange}
            placeholder="Frame number for start of washout"
            min="0"
          />
        </div>
        <div className="form-group">
          <label>Frame End Washout</label>
          <input
            type="number"
            name="frame_end_washout"
            value={formData.frame_end_washout}
            onChange={handleChange}
            placeholder="Frame number for end of washout"
            min="0"
          />
        </div>
        
        <div className="form-group">
          <label>Comments</label>
          <textarea
            name="comments"
            value={formData.comments}
            onChange={handleChange}
            placeholder="Additional comments or notes"
            rows="4"
          />
        </div>
        
        <button type="submit" className="label-create-btn">
          Create Label
        </button>
      </form>
    </div>
  );
};

export default LabelCreate;
